import { autoinject } from "aurelia-dependency-injection";
import { useView } from "aurelia-framework";
import { ValidationController } from "aurelia-validation";
import { StepModel } from "../../../../../../models/basics/basics.models";
import { MepScenarioPlanningRequest, MepScenarioPlanningTabsEnum } from "../../../../../../models/mep/mep-scenario-planning.models";
import { BaseMepFilterablePage } from "../../../../../../models/mep/mep.models";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { MepLookupService } from "../../../../../../services/mep/mep-lookup.service";
import { MepScenarioPlanningFilter } from "./partials/mep-scenario-planning-filter/mep-scenario-planning-filter";
import { MepScenarioPlanningShorePower } from "./partials/mep-scenario-planning-shore-power/mep-scenario-planning-shore-power";
import { MepScenarioPlanningPortTraffic } from "./partials/mep-scenario-planning-port-traffic/mep-scenario-planning-port-traffic";

@autoinject
@useView('views/pages/modules/mep/tabs/mep-scenario-planning/mep-scenario-planning.html')
export class MepScenarioPlanning extends BaseMepFilterablePage<MepScenarioPlanningFilter> {

    private portId: number;
    private refreshDataFunc: (request: MepScenarioPlanningRequest) => Promise<string[]>;
    public tabs: StepModel[] = [];
    public currentTab: StepModel;

    constructor(private notificationClientService: NotificationClientService,
        private mepLookupService: MepLookupService, private validationController: ValidationController,
        private mepScenarioPlanningPortTraffic: MepScenarioPlanningPortTraffic,
        private mepScenarioPlanningShorePower: MepScenarioPlanningShorePower,) {
        super();
        this.refreshDataFunc = (request: MepScenarioPlanningRequest) => this.loadScenarioPlanningData(request);
    }

    attached() {
        this.loadData();
    }

    activate(param) {
        this.portId = param.portId;

        if (!this.filterViewModel){
            this.initializeFilterVM();
        }

        //Intialize tabs
        this.intializeTabs();
    }

    initializeFilterVM(model?): MepScenarioPlanningFilter {
        this.filterViewModel = new MepScenarioPlanningFilter(model && model.portId ? model.portId : this.portId, this.refreshDataFunc,
            this.notificationClientService, this.mepLookupService, this.validationController);

        return this.filterViewModel;
    }

    loadScenarioPlanningData(request: MepScenarioPlanningRequest): Promise<string[]> {
        const promises = [];
        promises.push(this.currentTab.vm?.loadData(request, this.filterViewModel.selectedForecastYear));
        return Promise.all(promises);
    }

    tabChanged() {
        this.currentTab.vm.loadData(this.filterViewModel.getLastRequest(), this.filterViewModel.selectedForecastYear);
    }

    intializeTabs() {
        this.tabs = [{
            title: 'Port Traffic',
            step: MepScenarioPlanningTabsEnum.PortTraffic,
            show: true,
            vm: this.mepScenarioPlanningPortTraffic
        }, {
            title: 'Shore Power',
            step: MepScenarioPlanningTabsEnum.ShorePower,
            show: true,
            vm: this.mepScenarioPlanningShorePower
        // }, {
        //     title: 'Vessels',
        //     step: MepScenarioPlanningTabsEnum.Vessels,
        //     show: true,
        //     vm: this.mepScenarioPlanningVessels
        }];
    }

    public refresh(data?: { portId: number }) {
        this.filterViewModel.loadMepLookupFiltersHandler(data.portId);
        this.filterViewModel.clearAllFilters();
        this.loadData();
    }

    private loadData() {
        this.filterViewModel.initLookups().then(() => {
            this.filterViewModel.setDefaultFilters();
            this.filterViewModel.applyAllFilters();
        }).catch(() => {
            this.notificationClientService.show("MEP Error", "Error loading filters!", NotificationType.Error);
        });
    }
}